import { render } from "./MainTop.vue?vue&type=template&id=4aa56efc&scoped=true"
import script from "./MainTop.vue?vue&type=script&lang=js"
export * from "./MainTop.vue?vue&type=script&lang=js"

import "./MainTop.vue?vue&type=style&index=0&id=4aa56efc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa56efc"]])

export default __exports__